<template>
  <div class="single-coupon-send-page">
    <div class="step-tips">
      <section>
        <h2>方式一</h2>
        <p class="flex flex-align-center flex-wrap">
          点击右上角三个点
          <span class="ellipsis"><van-icon name="ellipsis" size="20" /></span>
          ，选择
          <van-icon color="#07c160" name="share-o" size="20" />
          【转发给朋友】
        </p>
      </section>
    </div>

    <div class="step-tips step-tips2">
      <section>
        <h2>方式二</h2>
        <p class="flex flex-align-center">复制优惠券链接发送给朋友</p>
        <p class="url">{{ url }}</p>
        <p>
          <van-button color="#b57e48" @click="copy">点击复制</van-button>
        </p>
      </section>
    </div>
    <div class="step-tips step-tips2">
      <section>
        <h2>方式三</h2>
        <p class="flex flex-align-center">二维码分享</p>
        <div
          v-if="!shareQrcode"
          id="html-canvas"
          class="url code text-center flex flex-v flex-pack-center flex-align-center"
        >
          <div id="qrcode" ref="qrcode" class="qrcode"></div>
          <h4>{{ detail.ProductName }}</h4>
        </div>
        <div v-if="shareQrcode">
          <img :src="shareQrcode" />
        </div>
      </section>
    </div>
    <div class="remark-tips">
      <h3>注意：</h3>
      <p>1、好友点击链接即可领取优惠券</p>
      <p>2、一条链接只能被一个用户使用，点击即可领取</p>
    </div>
  </div>
</template>
<script>
  import { wxShare, copyText, toImg } from '@/utils'
  import store from '@/store'
  import QRCode from 'qrcodejs2'
  import { Toast } from 'vant'
  export default {
    data() {
      return {
        url: '',
        query: this.$route.query,
        shareQrcode: '',
        loading: false,
        isDeactivated: false,
        detail: {},
      }
    },
    created() {
      //this.getDetail()
    },
    activated() {
      this.getDetail()
    },
    deactivated() {
      this.shareQrcode = ''
    },
    methods: {
      copy() {
        copyText(this.url)
      },
      getDetail() {
        const query = this.$route.query
        if (!query.packageId && !query.detailId) return
        let url = 'service/PackageGet'
        if (query.detailId) {
          url = 'service/GetPackageByDetailId'
        }
        store
          .dispatch(url, {
            packageId: query.packageId,
            packageDetailId: query.detailId,
          })
          .then((data) => {
            const { Data } = data
            this.detail = Data
            this.init()
            // if (!Data.Enable) {
            //   Toast('优惠券已停用')
            // } else {
            //   this.detail = Data
            // }
          })
          .catch((e) => {
            Toast(e.Message)
          })
      },
      async init() {
        const query = this.$route.query
        const H5Url = await store.getters['system/getH5Url']
        let url = H5Url + 'case/#/marketing/couponRecive'
        if (query.packageId) {
          url += '?packageId=' + query.packageId
        }
        if (query.detailId) {
          url += '?detailId=' + query.detailId
        }
        if (query.secret) {
          url += '&secret=' + query.secret
        }
        this.url = url
        wxShare(
          `${this.detail.ProductName}`,
          `点击领取【${this.detail.ProductName}】优惠券`,
          '',
          url
        )
        // const loading = Toast.loading({
        //   duration: 0,
        //   message: '加载中...',
        //   forbidClick: false,
        //   overlay: true,
        // })
        this.crateQrcode(url).then((data) => {
          const elem = document.getElementById('html-canvas')
          toImg(elem)
            .then((data) => {
              this.shareQrcode = data.toDataURL('image/jpeg', 1)
              //loading.clear()
            })
            .catch((e) => {
              //loading.clear()
            })
        })
      },

      // 生成二维码
      crateQrcode(text) {
        this.$refs.qrcode.innerHTML = ''
        return new Promise((resolve, reject) => {
          try {
            const qr = new QRCode('qrcode', {
              width: 160,
              height: 160, // 高度
              text: text, // 二维码内容
              colorDark: '#000000',
              colorLight: '#ffffff',
              correctLevel: QRCode.CorrectLevel.L,
            })
            resolve(qr)
          } catch (error) {
            //console.log(error)
          }
        })
      },
    },
  }
</script>
<style lang="scss" scoped>
  .single-coupon-send-page {
    padding: 16px 12px;
    .step-tips {
      background: #fff;
      border-radius: 3px;
      position: relative;
      box-shadow: 0 0.266667rem 0.4rem 0 rgb(0 0 0 / 4%);
      padding: 12px;
      font-size: 16px;
      color: #666;
      word-break: break-all;
      h2 {
        font-size: 18px;
        margin: 0;
        color: #333;
        margin-bottom: 6px;
      }
      &::after {
        content: '';
        position: absolute;
        right: 12px;
        top: -18px;
        width: 0;
        height: 0;
        border: 10px solid transparent;
        border-bottom-color: #fff;
      }
    }
    .step-tips2 {
      margin-top: 20px;
      &::after {
        display: none;
      }
      .url {
        background: #f9f9f9;
        padding: 8px;
        margin: 6px 0 10px;
        border-radius: 3px;
      }
      .code {
        padding: 16px;
        h4 {
          margin: 16px 0 0;
        }
      }
    }
  }

  .ellipsis {
    line-height: 1;
    background: #f1f1f1;
    border-radius: 2px;
    padding: 2px 3px;
  }
  .remark-tips {
    color: #666;
    font-size: 15px;
    h3 {
      font-size: 16px;
      margin: 20px 0 5px;
    }
  }
</style>
